import React from "react";
import { Box, Typography, Grid, Card, CardContent, Avatar, styled, Container, Divider } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

// ✅ Course Data defined within the file to fix 'no-undef'
const courses = [
    { title: "Java Developer", color: "#f44336", topics: ["Java Basics", "OOP", "Collections", "Multithreading", "Spring", "Advanced APIs"] },
    { title: "Python Developer", color: "#1976d2", topics: ["Python Basics", "Data Structures", "OOP", "Django/Flask", "Data Science", "Advanced Patterns"] },
    { title: "C++ Developer", color: "#9c27b0", topics: ["C++ Basics", "Pointers", "OOP", "STL", "Templates", "Advanced Features"] },
    { title: "C# Developer", color: "#4caf50", topics: ["C# Basics", "OOP", ".NET", "LINQ", "Entity Framework", "Advanced Patterns"] },
    { title: "Typescript Developer", color: "#ff9800", topics: ["TS Basics", "Interfaces", "Generics", "Decorators", "Angular/React", "Advanced TS"] },
    { title: "Spring Boot", color: "#009688", topics: ["Spring Boot Basics", "REST APIs", "JPA", "Security", "Microservices", "Advanced Boot"] },
    { title: "Express.js", color: "#795548", topics: ["Node Basics", "Routing", "Middleware", "REST APIs", "Auth", "Advanced Express"] },
    { title: "MongoDB", color: "#43a047", topics: ["NoSQL Basics", "CRUD", "Aggregation", "Indexing", "Replication", "Sharding"] },
    { title: "MySQL", color: "#2196f3", topics: ["SQL Basics", "Joins", "Procedures", "Indexes", "Optimization", "Advanced SQL"] },
    { title: "Postgres", color: "#673ab7", topics: ["Schemas", "Functions", "Indexes", "Extensions", "Optimization", "Advanced Features"] },
    { title: "Javascript", color: "#fbc02d", topics: ["JS Basics", "DOM", "ES6+", "Async/Await", "Frameworks", "Advanced Patterns"] },
    { title: "Github", color: "black", topics: ["Git Basics", "Branching", "Pull Requests", "CI/CD", "Actions", "Advanced Workflows"] },
    { title: "Linux", color: "#607d8b", topics: ["Shell Basics", "File System", "Networking", "Security", "Processes", "Advanced Admin"] },
    { title: "Embedded IoT", color: "#e91e63", topics: ["IoT Basics", "Microcontrollers", "Firmware", "Protocols", "RTOS", "Advanced IoT"] },
    { title: "Software Testing", color: "#ff5722", topics: ["Unit Testing", "Integration", "Automation", "Performance", "QA Tools", "Advanced Testing"] },
    { title: "HTML5 & CSS", color: "#e34f26", topics: ["HTML Basics", "CSS Fundamentals", "Flexbox", "Grid", "Responsive Design", "Advanced CSS"] },
];

const HeroSection = styled(Box)({
    height: "40vh",
    backgroundImage: `linear-gradient(rgba(16, 7, 32, 0.8), rgba(16, 7, 32, 0.8)), url('https://images.unsplash.com/photo-1499951360447-b19be8fe80f5')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    textAlign: "center",
    padding: "0 20px"
});

const SyllabusCard = styled(Card)({
    borderRadius: "20px",
    border: "1px solid #e2e8f0",
    height: "100%",
    transition: "0.3s",
    "&:hover": { transform: "translateY(-5px)", boxShadow: "0 12px 24px rgba(0,0,0,0.1)" }
});

export default function CoursePage() {
    return (
        <Box sx={{ bgcolor: "#F8FAFC", minHeight: "100vh" }}>
            <HeroSection>
                <Typography variant="h3" fontWeight={800}>Detailed Curriculum</Typography>
            </HeroSection>
            <Container maxWidth="lg" sx={{ py: 6 }}>
                <Grid container spacing={3}>
                    {courses.map((course, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <SyllabusCard>
                                <CardContent>
                                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                                        <Avatar sx={{ bgcolor: course.color, mr: 2 }}>{course.title[0]}</Avatar>
                                        <Typography variant="h6" fontWeight={700}>{course.title}</Typography>
                                    </Box>
                                    <Divider sx={{ mb: 2 }} />
                                    {course.topics.map((topic, i) => (
                                        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: course.color }} />
                                            <Typography variant="body2" color="text.secondary">{topic}</Typography>
                                        </Box>
                                    ))}
                                </CardContent>
                            </SyllabusCard>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
